import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MainCarousel from './MainCarousel';
import PackageSearcher from '../searcher/PackageSearcher';
import './mainSection.css';

export default function MainSection() {
  const [showForm, setShowForm] = useState(false);
  const { categoriesMainCarousel, ready, error } = useSelector((state) => state.bannersState);

  useEffect(() => {
    if (ready && !error) {
      categoriesMainCarousel.forEach((categoriaMainCarousel) => {
        if (categoriaMainCarousel.categoria?.ubicacion?.nombre === 'slider-con-buscador-paquetes')
          setShowForm(true);
      });
    }
  }, [categoriesMainCarousel]);

  return (
    <div className="lg:container relative">
      <div className={`${showForm ? 'home-header ' : ''}mx-0 lg:-mx-14`}>
        <MainCarousel showHomeOnly />
      </div>
      <div className="floating-searcher">
        <div className="container lg:p-0">{showForm && <PackageSearcher />}</div>
      </div>
    </div>
  );
}
